import {
  PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_ADMIN,
  PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_EDITOR,
  PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_VIEWER,
  PERMISSION_GECKO_INTERNAL_MEMBER,
  ROLE_CANTILEVER_DOCUMENT_NAVIGATOR_EDITOR,
  ROLE_CANTILEVER_DOCUMENT_NAVIGATOR_UPLOADER,
  ROLE_CANTILEVER_DOCUMENT_NAVIGATOR_VIEWER,
  type RolodexPermissionsValues,
} from 'types'

/** Any of these is enough to open Documents. */
export const DOCUMENT_NAVIGATOR_VIEW_PERMISSIONS: RolodexPermissionsValues[] = [
  PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_ADMIN,
  PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_VIEWER,
  PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_EDITOR,
  ROLE_CANTILEVER_DOCUMENT_NAVIGATOR_VIEWER,
  ROLE_CANTILEVER_DOCUMENT_NAVIGATOR_UPLOADER,
  ROLE_CANTILEVER_DOCUMENT_NAVIGATOR_EDITOR,
]

/** Upload UI: power editor/admin, or the Manage Access uploader add-on. */
export const DOCUMENT_NAVIGATOR_UPLOAD_PERMISSIONS: RolodexPermissionsValues[] =
  [
    PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_EDITOR,
    PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_ADMIN,
    ROLE_CANTILEVER_DOCUMENT_NAVIGATOR_UPLOADER,
  ]

const DOCUMENT_NAV_UPLOAD_ROLE_NAMES = new Set<string>([
  ROLE_CANTILEVER_DOCUMENT_NAVIGATOR_UPLOADER,
  ROLE_CANTILEVER_DOCUMENT_NAVIGATOR_EDITOR,
])

/** Nested leftover on the v3 viewer role; it does not gate upload UI. */
export const LEFTOVER_POWER_DOCUMENT_UPLOAD_EDITOR =
  'cantilever:power-document-upload:editor'

/**
 * v2/v3 overlap only: nested leftover upload/editor grants on the v3 viewer
 * role would otherwise look like upload permission. Strip those for
 * viewer-only members until v2 grants are gone. Gecko internals keep them.
 *
 * `viewerAssigned` says whether a v3 viewer grant exists at any site. It is
 * passed separately because the role names here are filtered to one site, and
 * the mask must hold at sites the viewer grant does not cover.
 */
export function applyDocumentNavigatorPermissionAliases(
  permissions: Set<string>,
  viewerAssigned: boolean = permissions.has(
    ROLE_CANTILEVER_DOCUMENT_NAVIGATOR_VIEWER
  )
): Set<string> {
  const hasV3UploadAddOn = [...DOCUMENT_NAV_UPLOAD_ROLE_NAMES].some((name) =>
    permissions.has(name)
  )
  if (
    viewerAssigned &&
    !hasV3UploadAddOn &&
    !permissions.has(PERMISSION_GECKO_INTERNAL_MEMBER)
  ) {
    permissions.delete(PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_EDITOR)
    permissions.delete(PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_ADMIN)
    permissions.delete(LEFTOVER_POWER_DOCUMENT_UPLOAD_EDITOR)
  }

  return permissions
}
